import { AbilityBuilder, Ability } from '@casl/ability';
import * as roles from '@/constants/roles';
import * as subjects from '@/constants/subjects';
import * as actions from '@/constants/actions';

export function defineRulesFor(role, rights) {
  const { can, rules } = new AbilityBuilder();

  if (role === roles.OWNER) {
    can(actions.READ, subjects.OWNER_PROFILE);
    can(actions.READ, subjects.ANNOUNCEMENTS);
    can(actions.READ, subjects.CHAT);
    can(actions.READ, subjects.OWNER_CALENDAR);
    can(actions.READ, subjects.OWNER_FINANCE);
  } else if (role === roles.MANAGEMENT_COMPANY_EMPLOYEE) {
    can(actions.READ, subjects.PROFILE);
    Object.entries(rights).forEach(([subject, { read, write }]) => {
      if (read) {
        can(actions.READ, subject);
      }

      if (write) {
        can(actions.UPDATE, subject);
      }
    });
  }

  return rules;
}

export default function defineAbilityFor(role, rights) {
  return new Ability(defineRulesFor(role, rights));
}
